import { render, staticRenderFns } from "./Contact-Persons.vue?vue&type=template&id=2818e6c2"
import script from "./Contact-Persons.vue?vue&type=script&lang=js"
export * from "./Contact-Persons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports